import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash-es';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/hooks/useAppSelector';

import { ALL_USERS_GROUP_ID } from '../constants';
import { fetchGroups, fetchGroupsNext } from '../services/actions';
import { selectGroups, selectGroupsApi } from '../services/selectors';
import { useGroupsWithLocalizedAllUsersGroup } from './useGroupsWithLocalizedAllUsersGroup';

export interface UseGroupsParams {
    onlyVisible?: boolean;
}

export const useGroups = (params?: UseGroupsParams) => {
    const [filter, setFilter] = useState('');
    const onlyVisible = params?.onlyVisible ?? false;

    const dispatch = useDispatch();

    const api = useAppSelector(selectGroupsApi);

    const data = useAppSelector(selectGroups);

    const dataWithLocalizedAllUsersGroup = useGroupsWithLocalizedAllUsersGroup(data);
    const dataWithoutAllUsersGroup = data.filter(group => group.id !== ALL_USERS_GROUP_ID);

    const handleLoadMore = () => {
        dispatch(fetchGroupsNext(filter, { onlyVisible }));
    };

    const handleSearch = useMemo(() => debounce(setFilter, 250), []);

    useEffect(() => {
        dispatch(fetchGroups(filter, { onlyVisible }));
    }, [dispatch, filter, onlyVisible]);

    return { api, data, dataWithLocalizedAllUsersGroup, dataWithoutAllUsersGroup, handleLoadMore, handleSearch, filter };
};
